// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"10372cb7","498":"1776da1c","513":"74e6429d","787":"b3b3af62"}[chunkId] + ".chunk.js";
};